import request from '../../utils/request';
import options from './options';

const urlPath = (url, path) => `${url}${path}`;

export const getCalculatorsSoilType = filter => request.get({
    url: urlPath(options.apiUrl, filter)
});

export const getCalculatorsSoilTypeItem = id => request.get({
    url: urlPath(options.apiUrl, `${id}/`)
});